import clsx from 'clsx';

interface Props {
  className?: string;
  number: number;
}

function NumberIcon({ className, number }: Props): JSX.Element {
  return (
    <div
      className={clsx(
        'm-0.5 flex h-5 w-5 items-center justify-center rounded-full border-2 border-green-500 text-xs font-semibold leading-none text-green-500',
        className,
      )}
    >
      {number}
    </div>
  );
}

export default NumberIcon;
